// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".themeChartBox{border:1px solid #e2e2e7;padding:0;margin:10px 0 0}.themeChartBox:hover{background:transparent}@media screen and (max-width:1000px){#media-IdxTable-PC{display:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
